import { createFileRoute } from "@tanstack/react-router";
import PointOfSaleScreen from "../Screens/PointOfSale";

export const Route = createFileRoute("/point-of-sale")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      "from-orders": search["from-orders"] as string | undefined,
    };
  },
});

function RouteComponent() {
  return <PointOfSaleScreen />;
}
